import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api, apiError } from "@/lib/api";
import { Loading } from "@/components/States";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function Radar() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["radar"], queryFn: async () => (await api.get("/radar")).data });

  const mut = useMutation({
    mutationFn: async (prefs) => (await api.put("/radar", { preferences: prefs })).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["radar"] }); },
    onError: (e) => toast.error(apiError(e)),
  });

  if (isLoading) return <Loading />;
  const { categories, preferences } = data;

  const toggle = (key, val) => {
    if (key === "emergencia") return;
    mut.mutate({ ...preferences, [key]: val });
  };

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display font-bold text-2xl tracking-tight">Meu Radar</h1>
        <p className="text-sm text-muted-foreground">Escolha o que você quer acompanhar no seu condomínio.</p>
      </div>

      <div className="glass rounded-3xl divide-y divide-white/5 overflow-hidden">
        {categories.map((c) => (
          <div key={c.key} data-testid={`radar-${c.key}`} className="flex items-center gap-3 p-4">
            <span className="text-xl">{c.icon}</span>
            <div className="flex-1">
              <p className="text-sm font-medium">{c.label}</p>
              {c.locked && <p className="text-xs text-muted-foreground flex items-center gap-1"><Lock className="w-3 h-3" /> Alertas críticos sempre ativos</p>}
            </div>
            <Switch
              data-testid={`radar-switch-${c.key}`}
              checked={!!preferences[c.key]}
              disabled={c.locked}
              onCheckedChange={(v) => toggle(c.key, v)}
            />
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground text-center px-6">
        Você recebe notificações apenas das categorias ativas. Emergências não podem ser desativadas para a sua segurança.
      </p>
    </div>
  );
}
